import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_4 = { class: "col-1 mt-3 mb-3" }
const _hoisted_5 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_8 = { class: "visually-hidden" }
const _hoisted_9 = {
  key: 1,
  ref: "startScroll",
  class: "row d-flex justify-content-center mt-4"
}
const _hoisted_10 = {
  key: 0,
  class: "col-xl-8 col-md-10 col-12 d-grid gap-2"
}
const _hoisted_11 = {
  class: "alert alert-danger d-flex justify-content-left",
  role: "alert"
}
const _hoisted_12 = {
  key: 1,
  class: "col-12 sm-10 col-md-8 col-xl-6 d-grid gap-2"
}
const _hoisted_13 = { class: "d-flex justify-content-center" }
const _hoisted_14 = { style: {"font-weight":"bold"} }
const _hoisted_15 = { class: "d-flex justify-content-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon-primary icon-lg",
  "aria-label": "mese avanti"
}, [
  /*#__PURE__*/_createElementVNode("use", {
    href: "#it-chevron-right",
    "xlink:href": "#it-chevron-right"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon-primary icon-lg",
  "aria-label": "mese indietro"
}, [
  /*#__PURE__*/_createElementVNode("use", {
    href: "#it-chevron-left",
    "xlink:href": "#it-chevron-left"
  })
], -1)
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  key: 0,
  class: "row d-flex justify-content-center mt-4"
}
const _hoisted_20 = { class: "col-1 mt-3 mb-3" }
const _hoisted_21 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_24 = { class: "visually-hidden" }
const _hoisted_25 = {
  key: 1,
  class: "row d-flex justify-content-center mt-5"
}
const _hoisted_26 = {
  key: 0,
  class: "col-xl-8 col-md-10 col-12 d-grid gap-2"
}
const _hoisted_27 = {
  class: "alert alert-danger d-flex justify-content-left",
  role: "alert"
}
const _hoisted_28 = { class: "d-flex justify-content-center" }
const _hoisted_29 = { style: {"font-weight":"bold"} }
const _hoisted_30 = ["onClick"]

import { computed, onMounted, ref, watch, inject, onUnmounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import { useTenantConfig } from "../../composables/useTenantConfig";
import api from "@/services/BookingService";
import _ from "lodash";

import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import { AxiosError } from "axios";
import { DateAvailableModel } from "@/models/Calendar/DateAvailableModel";
import { MonthAvailable } from "@/models/Step/MonthAvailableModel";
import { DayAvailable } from "@/models/Step/DayAvailableModel";
import { useI18n } from "vue-i18n";
import { IntervalAvailable } from "@/models/Step/IntervalAvailableModel";
import constants from "@/models/Utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookDateHour',
  setup(__props) {

const { getWebDelayDaysForLocation } = useTenantConfig();
const router = useRouter();
const store = useStore();
const { t } = useI18n();
const emitter = inject("emitter");

const startHourScrollRef = ref();

const selectedItem = ref(null);
const loadingDates = ref(false);
const datesAvailable = ref([] as DateAvailableModel[]);
const loadingIntervals = ref(false);
const intervalAvailables = ref([]);

const allowedDates = ref([]);
const calendarDate = ref(null);
const calendarMinDate = ref(null);
const calendarMaxDate = ref(null);
const calendarFormat = computed(() => {
    return t("settings.dateUIFormat");
});

const calendarLocale = computed(() => {
    return t("settings.localeCode");
});

watch(
    () => calendarDate.value,
    (newVal) => {
        if (newVal) {
            selectCalendarDate(newVal);
        }
    },
    { immediate: true },
);

watch(
    () => selectedItem.value,
    (newVal) => {
        if (newVal) {
            emitter.emit(constants.CAN_GO_NEXT_STEP, true);
            emitter.emit(constants.SCROLL_TO_NEXT_STEP);
        } else {
            emitter.emit(constants.CAN_GO_NEXT_STEP, false);
        }
    },
    { immediate: true },
);

onMounted(() => {
    store.stepsMade.month = null;
    store.stepsMade.day = null;
    store.stepsMade.interval = null;
    store.spidResponse = null;

    const localeCode = t("settings.localeCode");
    moment.locale(localeCode);

    emitter.on(constants.GO_NEXT_STEP, () => {
        console.log("received goNextStep BookDateHour");
        goToNextStep();
    });

    if (_.isNull(store.stepsMade) === false && _.isNull(store.stepsMade.service) === false && _.isNull(store.stepsMade.location) === false) {
        getData();
    }
});

const scrollToHourStart = () => {
    console.log(startHourScrollRef.value);
    if (startHourScrollRef.value) {
        startHourScrollRef.value.scrollIntoView({ behavior: "smooth" });
    }
};

const getData = () => {
    loadingDates.value = true;
    const delayDays = getWebDelayDaysForLocation(store.stepsMade.location.id);

    let friendlyCodeEditing = null;
    if (store.bookedit) {
        friendlyCodeEditing = store.bookedit.friendlyCode;
    }

    api.getNextDaysAvailability(store.tenantSelected.id, store.stepsMade.service.id, store.stepsMade.location.id, delayDays, "web", friendlyCodeEditing)
        .then((response) => {
            if (_.isNull(response) === false && _.isUndefined(response) === false) {
                if (_.isNull(response.data) === false && _.isUndefined(response.data) === false) {
                    if (_.isNull(response.data.availabilities) === false && _.isUndefined(response.data.availabilities) === false) {
                        if (_.isArray(response.data.availabilities) && response.data.availabilities.length > 0) {
                            for (let i = 0; i < response.data.availabilities.length; i++) {
                                let interval = response.data.availabilities[i];
                                // interval.dayName = _.upperFirst(interval.dayName);
                                // interval.monthName = _.upperFirst(interval.monthName);
                                datesAvailable.value.push(interval);
                                allowedDates.value.push(new Date(interval.year, interval.month - 1, interval.day));
                            }
                        }
                    }
                }
            }
            setCalendarStart();
            loadingDates.value = false;
        })
        .catch((err: AxiosError) => {
            console.log("Errore nella get delle prossime x disponibilità");
            loadingDates.value = false;
        });
};

const setCalendarStart = () => {
    let firstDateInterval = datesAvailable.value[0];
    let calendarStart = datesAvailable.value[0];
    calendarMinDate.value = new Date(calendarStart.year, calendarStart.month - 1, calendarStart.day);

    let calendarEnd = datesAvailable.value[datesAvailable.value.length - 1];
    calendarMaxDate.value = new Date(calendarEnd.year, calendarEnd.month - 1, calendarEnd.day);

    if (_.isNull(store.bookedit) === false) {
        const date = moment(store.bookedit.fromDate);
        const yearFromPreviousValue = date.year();
        const monthFromPreviousValue = date.month() + 1;
        const dayFromPreviousValue = date.date();

        let dateFromEditBooking = _.find(datesAvailable.value, function (o) {
            return o.year === yearFromPreviousValue && o.month === monthFromPreviousValue && o.day === dayFromPreviousValue;
        });

        if (dateFromEditBooking) {
            firstDateInterval = dateFromEditBooking;
        }
    }
    /*   calendarDate.value = new Date(
    firstDateInterval.year,
    firstDateInterval.month - 1,
    firstDateInterval.day
  ); */
};

const selectCalendarDate = (selectedDay: Date) => {
    let selectedDateAvailableModel = _.find(datesAvailable.value, function (o) {
        return o.year === selectedDay.getFullYear() && o.month === selectedDay.getMonth() + 1 && o.day === selectedDay.getDate();
    });
    if (selectedDateAvailableModel) {
        selectedDate(selectedDateAvailableModel);
    }
};

const selectedDate = (item: DateAvailableModel) => {
    if (_.isNull(item) === false && _.isUndefined(item) === false) {
        selectedItem.value = null;
        const monthStep = new MonthAvailable();
        monthStep.id = item.id;
        monthStep.month = item.month;
        monthStep.monthName = item.monthName;
        monthStep.year = item.year;
        monthStep.name = item.monthName + " " + item.year;
        store.stepsMade.month = monthStep;

        const dayStep = new DayAvailable();
        dayStep.id = item.id;
        dayStep.day = item.day;
        dayStep.dayName = item.dayName;

        store.stepsMade.day = dayStep;

        getIntervals();
    }
};

const removeDateFromAvailable = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    allowedDates.value = allowedDates.value.filter(
        (d: Date) => !(d.getFullYear() === year && d.getMonth() === month && d.getDate() === day)
    );
    datesAvailable.value = datesAvailable.value.filter(
        (d: DateAvailableModel) => !(d.year === year && d.month === month + 1 && d.day === day)
    );
};

const getIntervals = () => {
    loadingIntervals.value = true;
    intervalAvailables.value = [];

    let url = `v2/hours/${store.tenantSelected.id}/${store.stepsMade.location.id}/${store.stepsMade.service.id}/${store.stepsMade.month.year}/${store.stepsMade.month.month}/${
        store.stepsMade.day.day
    }/${"web"}`;

    if (store.bookedit) {
        url = url + `?bookingCode=${store.bookedit.friendlyCode}`;
    }

    api.getAvailableIntervals(url)
        .then((response) => {
            if (_.isNull(response) === false && _.isUndefined(response) === false) {
                if (_.isNull(response.data) === false && _.isUndefined(response.data) === false) {
                    if (_.isArray(response.data.intervalsAvailable) && response.data.intervalsAvailable.length > 0) {
                        for (let i = 0; i < response.data.intervalsAvailable.length; i++) {
                            const interval = response.data.intervalsAvailable[i];
                            intervalAvailables.value.push(interval);
                        }
                    }
                }
            }

            // If no time slots are available for the selected date, remove it from
            // the allowed dates so the datepicker disables it and the user cannot
            // select a fully-booked day again.
            if (intervalAvailables.value.length === 0 && calendarDate.value) {
                removeDateFromAvailable(calendarDate.value as Date);
            }

            loadingIntervals.value = false;
            // setTimeout(() => {
            //     scrollToHourStart();
            // }, 300);
        })
        .catch((err: AxiosError) => {
            console.log("Errore nella get degli orari");
            loadingIntervals.value = false;
        });
};

const selectedInterval = (item: IntervalAvailable) => {
    if (_.isNull(item) === false && _.isUndefined(item) === false) {
        selectedItem.value = item;
    }
};

const goToNextStep = () => {
    store.stepsMade.interval = selectedItem.value;
    router.push({ name: "bookformchoice" });
};

const isItemSelected = (item: IntervalAvailable) => {
    if (_.isNull(selectedItem.value) === false) {
        if (selectedItem.value.description === item.description) {
            return true;
        }
    }
    return false;
};

/* const bookEditHasSameInterval = (item: IntervalAvailable) => {
  if (_.isNull(store.bookedit) === false) {
    const fromHour = moment(store.bookedit.fromDate).format("HH:mm");
    const toHour = moment(store.bookedit.toDate).format("HH:mm");
    if (`${fromHour}-${toHour}` === item.description) {
      return true;
    }
  }
  return false;
}; */

const getStartIntervalDescription = (item: IntervalAvailable) => {
    return item.description.split("-")[0];
};

const bookEditHasSameDate = (item: DateAvailableModel) => {
    if (_.isNull(store.bookedit) === false) {
        const date = moment(store.bookedit.fromDate);
        const monthFromPreviousValue = date.month() + 1;
        const dayFromPreviousValue = date.date();

        if (monthFromPreviousValue === item.month && dayFromPreviousValue === item.day) {
            return true;
        }
    }
    return false;
};

onUnmounted(() => emitter.off(constants.GO_NEXT_STEP));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.selectBookingDateHour")), 1)
      ])
    ]),
    (loadingDates.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("common.loadingText")), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (datesAvailable.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)("messages.noAvailability")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t)("titles.selectDate")), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_unref(Datepicker), {
                    inline: "",
                    autoApply: "",
                    modelValue: calendarDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((calendarDate).value = $event)),
                    locale: calendarLocale.value,
                    allowedDates: allowedDates.value,
                    clearable: false,
                    enableTimePicker: false,
                    menuClassName: "dp-custom-menu",
                    minDate: calendarMinDate.value,
                    maxDate: calendarMaxDate.value,
                    format: calendarFormat.value,
                    preventMinMaxNavigation: "",
                    monthNameFormat: "long"
                  }, {
                    "calendar-header": _withCtx(({ index, day }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(index === 5 || index === 6 ? 'red-color' : '')
                      }, _toDisplayString(day), 3)
                    ]),
                    "arrow-right": _withCtx(() => [
                      _hoisted_16
                    ]),
                    "arrow-left": _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["modelValue", "locale", "allowedDates", "minDate", "maxDate", "format"])
                ])
              ]))
        ], 512)),
    (calendarDate.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (loadingIntervals.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23,
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)("common.loadingText")), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (intervalAvailables.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)("messages.noAvailability")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      ref_key: "startHourScrollRef",
                      ref: startHourScrollRef,
                      style: {"scroll-margin":"80px"},
                      class: "row d-flex justify-content-center"
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(t)("titles.selectTime")), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalAvailables.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-6 col-sm-4 col-md-4 col-lg-3 col-xl-2 my-3 d-grid gap-2",
                          key: item.id
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["btn btn-lg", [isItemSelected(item) ? 'btn-primary' : 'btn-outline-primary']]),
                            onClick: ($event: any) => (selectedInterval(item))
                          }, _toDisplayString(getStartIntervalDescription(item)), 11, _hoisted_30)
                        ]))
                      }), 128))
                    ], 512))
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})